module.exports = __webpack_public_path__ + "img/上对齐.cca61dda.svg";